import {frontend} from 'pageflow-scrolled/frontend';

import {CtaButton} from './CtaButton';

frontend.contentElementTypes.register('ctaButton', {
  component: CtaButton,
  defaultMarginTop: '2rem'
});
